import { render, staticRenderFns } from "./HistoryPickupDetails.vue?vue&type=template&id=b943f9b6&"
import script from "./HistoryPickupDetails.vue?vue&type=script&lang=js&"
export * from "./HistoryPickupDetails.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPickupDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports